import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Button,
  Divider,
  LinearProgress,
  styled,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import Card from "@mui/material/Card";
import { ErrorButton, SecondaryButton } from "../../../components/ui/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setProdcuctName,
  setSelectedIndex,
  setSelectDisbDetailIndex,
} from "../../../services/redux/slices/tabsSlice";
import { InputField } from "../../../components/ui/Inputs";
import LoanManagementImg from "../../../assets/images/loan_management.png";
import { setSelectedloanAccountNumber } from "../../../services/redux/slices/optionSlice";
import { setloanAccountNumberOptions } from "../../../services/redux/slices/optionSlice";
import {
  Box,
  height,
  padding,
  textAlign,
  useMediaQuery,
  useTheme,
} from "@mui/system";
import {
  formatIndianRupees,
  handlePercentAmount,
  checkPercentage,
} from "../../../utils/formatting";
import {
  setDashboardData,
  setExistDisbursementStatus,
  setIsShowReferralBanner,
  setMoratStatus,
  setSelectedLoanNumber,
} from "../../../services/redux/slices/dashboardDataSlice";
import { ROUTES } from "../../../routes/routerConfig";
import {
  authSelector,
  userLoanCatSelector,
  setUserBusinessType,
} from "../../../services/redux/slices/authSlice";
import {
  setStatusPopup,
  statusPopupSelector,
} from "../../../services/redux/slices/statusPopupSlice";
import {
  messages,
  quickLinks,
  validStatuses,
  referralBannerCarousel,
  referralLinkMap,
  awsReferralBannerDesktop
} from "../../../data/constant";
import { termLoanPermissionCheck } from "../../../utils/helpers";
import {
  cleardisbursementButtonSlice,
  setdisbursementButtonValue,
} from "../../../services/redux/slices/disbursementButtonSlice";
import { encrypt } from "../../../utils/crypto";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  SmallButton,
  OutlinedSmallButton,
} from "../../../components/ui/Button";
import { PrimaryButton } from "../../../components/ui/Button";

import Skeleton from "@mui/material/Skeleton";
import AccountSelector from "../../../components/ui/AccountSelectorWithLable";

import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import postsServices from "../../../services/api/service/postsService";
import CustomTabs from "../../../components/ui/Tabs";
import LoanCards from "../../../components/ui/LoanCards";
import CustomCard from "../../../components/ui/CustomCard";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { faqUrl } from "../../../data/constant";
import { iconsAndTitles } from "../../../data/constant";
import AllProductIcon from "../../../assets/images/allproduct.png";
import HeadingLeftRight from "../../../components/ui/HeadingLeftRight";
import DocumentTerm from "../../../pages/dashboard/termLoan/DocumentTerm";
import { RootState } from "../../../services/redux/store";
import DisbursementHistoryTable from "../../../pages/dashboard/termLoan/DisbursementHistoryTable";
import PaymentTermLoan from "../../../pages/dashboard/termLoan/PaymentTermLoan";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import { decrypt } from "../../../utils/crypto";
import DisbursementContainer from "./DisbursementContainer";
import {
  formatDate,
  formatNumberToTwoDecimals,
} from "../../../utils/dateFormatUtils";
import { setNotificationtype } from "../../../services/redux/slices/notificationSlice";
import InfoIcon from "../../../assets/images/icons/info.png";
import { addNotification } from "../../../services/redux/slices/toastNotificationSlice";
import { clearPartPaymentType } from "../../../services/redux/slices/documentFormSlice";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";
import CardItemList from "../../../components/ui/mobile/CardItemList";
import queryString from "query-string";
import service from "../../../services/api/service";
import CardItemListDashboard from "../../../components/ui/mobile/CardItemListDashboard";
import CardItemListHistory from "../../../components/ui/mobile/CardItemListHistory";
import ModalPopup from "../../../components/ui/ModalPopup";
import { Controller, useForm } from "react-hook-form";
import SelectOptions from "../../../components/ui/SelectOptions";
import SearchSelectOptions from "../../../components/ui/SearchSelectOption";
import ReactGA from 'react-ga4';
import { trackEvent } from "../../../utils/ga";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AwsOfferModal from "../AwsOfferModal";

interface Payload {
  cif?: any;
  business?: any;
  loanCategory?: any;
  lan?: any;
}

interface DashboardData {
  lanNumber: string;
  statusOfLoan: string;
  loanAmount: number;
  outstandingPrincipal: number;
  emiAmount: number;
  nextEmiDate: string;
  overdueAmount: number;
  description: string;
  firstDisbDate: string;
  maturityDate: string;
  loanTypeId: number;
  isExistDisbursementAllowdLoan: boolean;
  status: string;
}
interface CustomToggleButtonProps {
  ownerState?: {
    selected: boolean;
  };
}
const CustomToggleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "ownerState",
})<CustomToggleButtonProps>(({ theme, ownerState }) => ({
  ...(ownerState?.selected && {
    backgroundColor: theme.palette.primary.main,
    color: "#072c2c",
    boxShadow: `0px 4px 12px 0px #5A5A5A2B`,
    background: `#fff`,
    borderRadius: `5px`,
    fontWeight: 600,
  }),
}));
const TermLoanDashboard = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    getValues,
    formState: { errors },
  } = useForm<any>();

  const [mobileNumberError, setMobileNumberError] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [TermLoanDashboardData, setTermLoanDashboardData] = useState<any[]>([]);
  const { userProfile, businessType } = useSelector(authSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingView, setIsLoadingView] = useState(true);
  const [quickHelpData, setQuickHelpData] = useState([]);
  const [fetchNotificatinData, setFetchNotificatinData] = useState([]);
  const [isAwsOfferModalOpen, setIsAwsOfferModalOpen] = useState<boolean>(false);
  const selectedIndex = useSelector(
    (state: RootState) => state?.tabs?.selectedIndex ?? "0"
  );
  const selectedloanAccountNumber = useSelector(
    (state: RootState) => state.option.selectedloanAccountNumber ?? ""
  );
  const loanAccountNumberOptions = useSelector(
    (state: RootState) => state?.option?.loanAccountNumberOptions
  );
  // Selecting loan number from Redux state
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber ?? ""
  );
  const isShowReferralBanner = useSelector(
      (state: RootState) => state?.dashboardData?.isShowReferralBanner
  );

  const sanctionedDisbursedData = useSelector(
      (state: RootState) => state?.dashboardData?.sanctionedDisbursedData
  );

  const navigate = useNavigate();
  const location = useLocation();
  const [withdrawLanNumber, setWithdrawLanNumber] = useState("");
  const { refreshValue } = useSelector(statusPopupSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const [alignment, setAlignment] = React.useState<string>("Term Loan");
  const [selectedLoan, setSelectedLoanVal] = useState<any>(null);
  const [selected, setSelected] = useState("termLoan");
  const [countryList, setCountryList] = useState<any>([]);

  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  const tabType = useSelector((state: RootState) => state.tabs.tabType);
  const [formValue, setFormValue] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    countryCodeId: "",
    emailId: "",
    countryId: "",
    course: "",
  });

  const ImageSection = styled(Card)({
    // backgroundSize: "contain",
    // backgroundPosition: "center",
    maxHeight: "172px",
    width: "100%",
    // display: "block",
    // backgroundImage: `url(${AllProductIcon})`, // Replace with your image path
    cursor: "pointer",
  });

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (!isLoadingView) {

      trackEvent(tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label, decrypt(userProfile?.id), {
        label: tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label,
        category: 'Tabs',
        action: tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label,
      });

      const cleanPath = location.pathname;
      navigate(cleanPath, { replace: true });
      localStorage.removeItem("termLoanRequestId");
      dispatch(cleardisbursementButtonSlice());
      if (newValue == 1) {
        if (
          TermLoanDashboardData?.[0]?.isExistDisbursementAllowdLoan &&
          TermLoanDashboardData?.[0]?.status === "A"
        ) {
          dispatch(clearPartPaymentType());
          dispatch(setSelectedIndex(newValue));
          localStorage.removeItem("activeFormStep");
          dispatch(cleardisbursementButtonSlice());
          dispatch(setdisbursementButtonValue(""));
        } else {
          dispatch(
            setStatusPopup({
              status: "no access",
              // message: `Disbursement requests are not permitted for this loan.`,
              message:
                "Disbursement requests are currently unavailable for this loan",
            })
          );
        }
      } else {
        if (newValue === 2) {
          if (
            ["M", "C", "W", "E", "S"]?.includes(
              TermLoanDashboardData?.[0]?.status
            )
          ) {
            dispatch(
              setStatusPopup({
                status: "no access",
                // message: `Disbursement requests are not permitted for this loan.`,
                message:
                  "Payment requests are currently unavailable for this loan",
              })
            );
          } else {
            dispatch(clearPartPaymentType());
            dispatch(setSelectedIndex(newValue));
          }
        } else {
          dispatch(clearPartPaymentType());
          dispatch(setSelectedIndex(newValue));
        }
      }

      // if (newValue === 1) {
      //   dispatch(setSelectedIndex(newValue));
      //   // requestForDisbursement(selectedloanAccountNumber, TermLoanDashboardData?.[0]?.isExistDisbursementAllowdLoan);
      // } else {
      //   dispatch(setSelectedIndex(newValue));
      // }
    }

  };


  // Retrieve data when the component mounts
  useEffect(() => {
    if (selectedIndex == 0) {
      dispatch(cleardisbursementButtonSlice());
    }
  });
  const parseCustomQueryString = (queryString: any) => {
    const cleanedQueryString = queryString.startsWith("?")
      ? queryString.substring(1)
      : queryString;

    const correctedQueryString = cleanedQueryString.replace(/\?/g, "&");
    const paramPairs = correctedQueryString.split("&");
    const params: any = {};

    paramPairs.forEach((pair: any) => {
      const [key, value] = pair.split("=");

      if (key && value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });

    return params;
  };
  useEffect(() => {
    setIsLoading(false);
    const parsedParams = parseCustomQueryString(window.location.search);

    if (window.location.pathname === "/dashboard" && ("error" in parsedParams || "paymentRequestId" in parsedParams)) {
      dispatch(setSelectedIndex(2));
    } else if(window.location.pathname === "/dashboard" && parsedParams?.consent === "true") {
      dispatch(setdisbursementButtonValue('createNewRequestBtn'))
      dispatch(setSelectedIndex(1));
    }
  }, [window.location?.search, window.location?.pathname]);

  useEffect(() => {
    if (loanAccountNumberOptions?.length < 1 || !loanAccountNumberOptions) {
      setIsLoading(true);
      if (businessType?.id != undefined || tabType == "Flexi Term Loan") {
        const payload: Payload = {
          cif: userProfile?.cifNumber,
          business: encrypt(businessType?.id),
          loanCategory: encrypt(userLoanCategory?.TermLoan[0]?.loanCategoryId),
        };
        postsServices
          .addPost("api/v1/dashboard/term-loans", payload)
          .then((response) => {
            let filterLoanAccountNumber = response?.data?.data?.map(
              (acc: any) => acc.lanNumber
            );
            let loan = selectedLoanNumber;
            dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
            const parsedParams = parseCustomQueryString(window.location.search);
            if (window.location.pathname === "/dashboard" && ("error" in parsedParams || "paymentRequestId" in parsedParams)) {
                const loanNo = "error" in parsedParams ? parsedParams?.loanNo : parsedParams?.LoanNo;
                dispatch(setSelectedloanAccountNumber(loanNo));
                dispatch(setSelectedLoanNumber(loanNo));
                loan = loanNo;
            } else if(window.location.pathname === "/dashboard" && parsedParams?.consent === "true") {
                const loanNo = localStorage.getItem("selectedLanNumber");
                loan = loanNo;
                dispatch(setSelectedloanAccountNumber(loanNo));
                dispatch(setSelectedLoanNumber(loanNo));
                dispatch(setSelectedIndex(1));
            }
            if (!loan) {
              dispatch(
                setSelectedloanAccountNumber(
                  response?.data?.data && response?.data?.data[0]?.lanNumber
                )
              );
              dispatch(
                setSelectedLoanNumber(
                  response?.data?.data && response?.data?.data[0]?.lanNumber
                )
              );
            }
            setIsLoading(false);
            //fetchData();
          })
          .catch((error: any) => {
            setIsLoading(false);
            const errorMessage =
              error.response?.data?.message ||
              messages.withdrErrorMessages.commonError;
            dispatch(
              setStatusPopup({
                status: "error",
                message: errorMessage,
              })
            );
          });
      }
    }
  }, [userProfile?.cifNumber]);

  useEffect(() => {

    if (selectedLoanNumber && selectedLoanNumber !== "") {
      setIsLoadingView(true);
      const payload: any = {
        lan: encrypt(selectedLoanNumber.toString()),
        business: encrypt(businessTypeId),
        loanCategory: encrypt(loanCategoryData?.TermLoan[0]?.loanCategoryId)
      };
      postsServices
        .addPost("api/v1/dashboard/term-loan-view", payload)
        .then((response) => {
          setIsLoadingView(false);
          setTermLoanDashboardData(response?.data?.data);
          if(response?.data?.data?.length > 0) {
            dispatch(setIsShowReferralBanner(true));
          }
          dispatch(setDashboardData(response?.data?.data));
          dispatch(setMoratStatus(response?.data?.data));
        })
        .catch((error) => {
          setIsLoadingView(false);
          const errorMessage =
            error.response?.data?.message ||
            messages.withdrErrorMessages.commonError;
          dispatch(
            setStatusPopup({
              status: "error",
              // message: `Disbursement requests are not permitted for this loan.`,
              message: errorMessage,
            })
          );
        });
    }
  }, [selectedLoanNumber]);

  useEffect(() => {
    const fetchQuickHelp = () => {
      setIsLoading(true);
      postsServices
        .addPost("api/v1/dashboard/quick-help")
        .then((response) => {
          setQuickHelpData(response?.data?.data);
        })
        .catch((error: any) => {
          const errorMessage =
            error.response?.data?.message ||
            messages.withdrErrorMessages.commonError;
        });
    };

    fetchQuickHelp();
  }, [refreshValue, userProfile?.cifNumber]);
  const dispatch = useDispatch();

  const handleViewDetailsClick = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any
  ) => {
    if (termLoanPermissionCheck()) {
      dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(TermLoanDashboardData)); //
      dispatch(setExistDisbursementStatus(isExistDisbursementAllowdLoan));
      dispatch(setSelectedLoanNumber(loanAccountNumber));
      //navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
      //dispatch(setSelectedIndex(0)); // Set index for "My Account" tab
      dispatch(setProdcuctName("TermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  };

  const sortedTermLoanData = useMemo(() => {
    const filteredTermLoan = TermLoanDashboardData
      ? TermLoanDashboardData?.filter(
        (data: any) =>
          data.loanAccountNumber === selectedLoanNumber ||
          data.lanNumber === selectedLoanNumber
      )
      : []; // Return an empty array if TermLoanDashboardData is not available

    const displayData =
      filteredTermLoan &&
      [
        filteredTermLoan?.find((data: any) => data?.status === "A") ||
        filteredTermLoan?.[0],
      ].filter(Boolean);

    return displayData;
  }, [TermLoanDashboardData, selectedLoanNumber]);

  useEffect(() => {
    if (TermLoanDashboardData) {
      handleViewDetailsClick(
        TermLoanDashboardData[0]?.lanNumber,
        TermLoanDashboardData[0]?.isExistDisbursementAllowdLoan
      );
      if (!selectedLoanNumber || selectedLoanNumber == undefined) {
        dispatch(
          setSelectedloanAccountNumber(TermLoanDashboardData[0]?.lanNumber)
        );
        dispatch(setSelectedLoanNumber(TermLoanDashboardData[0]?.lanNumber));
      }
    }
  }, [TermLoanDashboardData]);

  const requestForDisbursement = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any,
    status: any
  ) => {
    trackEvent('DashboardOverview_Request_Disbursement', decrypt(userProfile?.id), {
      label: 'DashboardOverview_Request_Disbursement',
      category: 'DashboardOverview_Request_Disbursement',
      action: "DashboardOverview_Request_Disbursement",
    });

    // ReactGA.event({
    //   category: 'DashboardOverview_Request_Disbursement',
    //   action: 'DashboardOverview_Request_Disbursement',
    //   label: 'DashboardOverview_Request_Disbursement',
    //   value: Number(decrypt(userProfile?.id)),
    // });

    if (isExistDisbursementAllowdLoan === true && status === "A") {
      if (termLoanPermissionCheck()) {
        dispatch(cleardisbursementButtonSlice());
        dispatch(setSelectedloanAccountNumber(loanAccountNumber));
        dispatch(setDashboardData(TermLoanDashboardData));
        dispatch(setSelectedLoanNumber(loanAccountNumber));
        //navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
        dispatch(setSelectedIndex(1)); // Set index for "My Account" tab
       // dispatch(setProdcuctName("TermLoanDisbursement"));
      } else {
        dispatch(
          setStatusPopup({
            status: "no access",
            message: `${messages.noPermission.module} "Account Summary"`,
          })
        );
      }
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          // message: `Disbursement requests are not permitted for this loan.`,
          message:
            "Disbursement requests are currently unavailable for this loan",
        })
      );
    }
  };

  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));
  const MultiColorProgressBarMobile = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: "5px",
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));

  const tabsContent: any = [
    { label: "Dashboard", content: "" },
    { label: "Fund Request", content: "" },
    { label: "Payment", content: "" },
    { label: "Documents", content: "" },
    { label: "History", content: "" },
  ];

  const handleRightSectionClick = () => {
    trackEvent('ViewAll_Loans', decrypt(userProfile?.id), {
      label: 'ViewAll_Loans',
      category: 'ViewAll_Loans',
      action: 'ViewAll_Loans',
    });

    navigate("/dashboard/term-loan/view-all-loans");
  };
  const handleViewAll = () => {
    trackEvent('ViewAll_Disbursment', decrypt(userProfile?.id), {
      label: 'ViewAll_Disbursment',
      category: 'ViewAll_Disbursment',
      action: 'ViewAll_Disbursment',
    });
    dispatch(setSelectedIndex(4));
  };

  const handleGetCountryListOrSubmit = (type: string) => {

    trackEvent('Refer a Friend', decrypt(userProfile?.id), {
      label: 'Refer Friend',
      category: 'Refer a Friend',
      action: 'Refer Friend',
    });

    let payload: any = {};

    if (type == "COUNTRY") {
      payload["type"] = 1;
    } else {
      payload["type"] = 2;
      payload["firstName"] = formValue.firstName;
      payload["lastName"] = formValue.lastName;
      payload["phone"] = formValue.phone;
      payload["emailId"] = formValue.emailId;
      payload["countryId"] = formValue.countryId;
      payload["course"] = formValue.course;
      payload["countryCodeId"] = formValue.countryCodeId;
    }

    service.posts
      .addPost(`api/v1/customer/referral`, payload)
      .then((response) => {
        const data = response?.data?.data || [];
        if (type == "COUNTRY") {
          setIsModalOpen(true);
          setCountryList(data);
        } else {
          dispatch(
            setStatusPopup({
              status: "success",
              message: "Request submitted successfully",
            })
          );
          setIsModalOpen(false);
        }
      })
      .catch((error) => {
        dispatch(
          setStatusPopup({
            status: "error",
            message: "Something went wrong !",
          })
        );
        setIsLoading(false);
      });
  };

  const isInitialMount = useRef(true);

  const handleContinue = () => {
    if (formValue?.phone?.length < 7) {
      setMobileNumberError("Phone number must be at least 7 digits.");
      return;
    } else {
      handleGetCountryListOrSubmit("SUBMIT");
    }
  };

  const handleSetFormValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValue((prevFormValue) => ({
      ...prevFormValue,
      [name]: value,
    }));
  };

  const handleSetCountryField = (value: any) => {
    setFormValue((prevFormValue) => ({
      ...prevFormValue,
      countryId: value,
    }));
  };

  const handleSetPhoneCode = (value: any) => {
    const oldObj = formValue;
    setFormValue((prevFormValue) => ({
      ...prevFormValue,
      countryCodeId: value,
    }));
  };

  const isShowBanner = () => {
    if((sanctionedDisbursedData[0]?.status === "A" || TermLoanDashboardData[0]?.status === "A") &&
    (TermLoanDashboardData[0]?.loanTypeName === "ELFORN" || TermLoanDashboardData[0]?.loanTypeName === "ELDOMC")) {
      return true
    }
    return false
  }

  const isShowOtherBannerWithoutCarousel = () => {
    if((sanctionedDisbursedData[0]?.status === "A" || TermLoanDashboardData[0]?.status === "A") &&
    (TermLoanDashboardData[0]?.loanTypeName !== "ELFORN" && TermLoanDashboardData[0]?.loanTypeName !== "ELDOMC")) {
      return true
    }
    return false
  }

  const LoanCardSkeleton = () => {
    return (
      <>
        {!isXsOrSm && (
          <Box sx={{ width: "100%", px: 3 }}>

            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box>
                <Skeleton width={280} height={28} />
                <Skeleton width={200} height={20} />
              </Box>

              <Skeleton variant="rectangular" width={150} height={36} />
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Main Layout */}
            <Grid container spacing={3}>

              {/* Left */}
              <Grid item xs={12} md={7}>
                <Grid container spacing={2}>
                  {[...Array(6)].map((_, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                      <Skeleton width="60%" />
                      <Skeleton width="80%" height={24} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              {/* Right */}
              <Grid item xs={12} md={5}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Skeleton variant="rectangular" width={6} height={180} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton height={20} width="60%" />
                    <Skeleton height={28} width="50%" sx={{ my: 1 }} />
                    <Skeleton height={20} width="40%" />
                    <Skeleton variant="rectangular" height={10} sx={{ mt: 2 }} />
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </Box>
        )}


        {isXsOrSm && (
          <Box className="dashboard-container-mobile" sx={{px: 2, py: 2}}>
            <Grid
              container
              className="active-button-container"
              sx={{ marginTop: "10px" }}
            >
              <Grid item xs={9}>
                <Box>
                  <Skeleton variant="text" width="80%" height={40} />
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Typography>
                  <Skeleton variant="text" width="50%" height={40} />
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 3 }}>
              <Grid item xs={6}>
                <Skeleton variant="rectangular" width="80%" height={40} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="rectangular" width="80%" height={40} />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={10} />
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 3 }}>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 3 }}>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" />
                <Skeleton variant="text" width="80%" />
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 4 }}>
              <Grid item xs={12}>
                <Skeleton variant="rectangular" width="100%" height={50} />
              </Grid>
            </Grid>
          </Box>
        )}
      </>
    );
  };
  // useEffect(() => {
  //   // Function to handle the window width check
  //   const handleResize = () => {
  //     if (window.innerWidth > 768) {
  //       // Target only non-mobile devices
  //       (document.body.style as any).zoom = "80%"; // Cast to any to avoid TypeScript error
  //     } else {
  //       (document.body.style as any).zoom = "100%"; // Reset zoom for mobile
  //     }
  //   };

  //   // Run the function initially
  //   handleResize();

  //   // Add event listener for resizing
  //   window.addEventListener("resize", handleResize);

  //   // Cleanup function to remove the event listener
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []); // Empty dependency array ensures it runs only once on mount
  const handleChangeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment == "Term Loan") {
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.TermLoan[0]?.businessId,
          name: "retail",
        })
      );
    } else {
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.Flexi[0]?.businessId,
          name: "flexi",
        })
      );
    }
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      // if (setToggle) {
      //   setToggle(newAlignment); // This will update the alignment in MainDashboard
      // }
    }
    dispatch(setNotificationtype(newAlignment));
  };
  let spacing = 4;
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  if (isXsOrSm) {
    spacing = 0;
  }

  const phoneCodeOptions: any =
    countryList
      ?.filter(
        (pc: any, index: number, self: any[]) =>
          index === self.findIndex((p) => p.countryCode === pc.countryCode)
      )
      .sort((a: any, b: any) => a.countryCode - b.countryCode)
      .map((pc: any) => ({
        value: pc.id,
        label: `+${pc.countryCode}`,
      })) || [];

  return (
    <React.Fragment>
      {!isXsOrSm && (
        <Box>
          <CustomTabs
            content={tabsContent}
            onChange={handleChange}
            value={selectedIndex}
          />
        </Box>
      )}
      {selectedIndex === 0 && (
        <Box sx={{ width: "100%" }}>
          <Grid container>
            {isLoadingView ? (
              <>
                {[1].map((item, index) => (
                  <Card key={index} sx={{width: "100%"}}>
                    <LoanCardSkeleton />
                  </Card>
                ))}
              </>
            ) : (
              <>
                {/* {isXsOrSm && (
                  <>
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      sx={{
                        display: {
                          color: "rgba(39, 87, 92, 1)",
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "25px",
                        },
                      }}
                    >
                      Welcome back {userProfile?.name} 👋
                    </Typography>
                    <Typography
                      variant="h5"
                      noWrap
                      component="div"
                      sx={{
                        display: {
                          xs: "block",
                          sm: "block",
                          md: "block",
                          color: "rgba(112, 117, 121, 1)",
                          fontWeight: "500",
                          fontSize: "12px",
                          lineHeight: "22px",
                        },
                      }}
                    >
                      Monitor all your loan accounts from here
                    </Typography>
                  </>
                )} */}
                <Box sx={{ width: "100%" }}>
                  <HeadingLeftRight
                    titleone="Overview"
                    titletwo="View all loans"
                    onRightSectionClick={handleRightSectionClick}
                    displayC="true"
                  />
                  {TermLoanDashboardData.map((item: any, index: number) => (
                    <>
                      <Box className="dashboard-container no-flex">
                        <Card
                          sx={{
                            padding: "15px 25px 25px",
                            borderRadius: "6px",
                            border: "1px solid rgba(0, 179, 181, 1)",
                          }}
                        >
                          {!isXsOrSm && (
                            <>
                              <Grid
                                container
                                sm
                                className="active-button-container"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  sm={8}
                                  md={8}
                                  lg={8}
                                  sx={{ height: "22px" }}
                                >
                                  <Typography
                                    variant="h6"
                                    // className="cardHead"
                                    className="loan-account-main-heading"
                                  >
                                    Loan A/c {item?.lanNumber}
                                    <Typography
                                      className="active-button"
                                      style={{
                                        color:
                                          item?.status === "A"
                                            ? "#28C76F"
                                            : "#EA5455",
                                        backgroundColor:
                                          item?.status === "A"
                                            ? "#28C76F29"
                                            : "#EA545529",
                                      }}
                                    >
                                      {item?.status === "A"
                                        ? "Active"
                                        : "Closed"}
                                    </Typography>
                                  </Typography>
                                  <Typography className="loan-account-sub-heading">
                                    {item?.description}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "right",
                                    alignItems: "right",
                                  }}
                                >
                                  <OutlinedSmallButton
                                    title={"Request Fund Release"}
                                    click={() =>
                                      requestForDisbursement(
                                        item?.lanNumber,
                                        item?.isExistDisbursementAllowdLoan,
                                        item?.status
                                      )
                                    }
                                  />
                                </Grid>
                              </Grid>
                              <Grid container sm sx={{ paddingTop: "20px" }}>
                                <Grid item sm={12}>
                                  <Divider
                                    sx={{
                                      border: isXsOrSm
                                        ? ""
                                        : "1px solid rgba(219, 218, 222, 1)",
                                      borderColor: isXsOrSm
                                        ? "rgba(0, 0, 0, 0.12)"
                                        : "",
                                      borderBottomWidth: isXsOrSm ? "thin" : "",
                                      width: "100%",
                                    }}
                                  />
                                </Grid>
                              </Grid>{" "}
                            </>
                          )}
                          {isXsOrSm && (
                            <>
                              <Grid
                                container
                                className="active-button-container"
                                style={{ marginTop: "5px" }}
                              >
                                <Grid item xs={9} sm={9} md={7} lg={7}>
                                  <Box sx={{ float: "left" }}>
                                    <AccountSelectorDropDown
                                      labelText="Loan account number"
                                      buttonText=" N/A"
                                      isActive={""}
                                      backgroundColor="transparent"
                                      borderWidth="0px"
                                      marginTop="0px"
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={3} sm={3} md={5} lg={5}>
                                  <Typography
                                    className="active-button-mobile"
                                    style={{
                                      color:
                                        item?.status === "A"
                                          ? "#28C76F"
                                          : "#EA5455",
                                      backgroundColor:
                                        item?.status === "A"
                                          ? "#28C76F29"
                                          : "#EA545529",
                                    }}
                                  >
                                    {item?.status === "A" ? "Active" : "Closed"}
                                  </Typography>
                                </Grid>
                                <Divider
                                  sx={{
                                    border: isXsOrSm
                                      ? ""
                                      : "1px solid rgba(219, 218, 222, 1)",
                                    borderColor: isXsOrSm
                                      ? "rgba(0, 0, 0, 0.12)"
                                      : "",
                                    borderBottomWidth: isXsOrSm ? "thin" : "",
                                    width: "100%",
                                    marginTop: "6px",
                                  }}
                                />
                              </Grid>
                              <Grid container sm className="mt-20">
                                <Grid
                                  item
                                  xs={12}
                                  sm={5}
                                  md={5}
                                  lg={5}
                                  className="mb-20"
                                >
                                  <div style={{ display: "flex" }}>
                                    {!isXsOrSm && (
                                      <div className="line-container">
                                        <div className="line vertical"></div>
                                        <div className="line vertical"></div>
                                      </div>
                                    )}
                                    <Grid
                                      container
                                      sm
                                      className="muiLinearProgress"
                                    >
                                      {/* Utilised Section */}
                                      <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        className="right-border"
                                      >
                                        <Typography className="mainHeadingLable muiLinear-progress-p">
                                          <img
                                            src={UtilizedIcon}
                                            alt="Available"
                                            style={{
                                              height: "22px",
                                            }}
                                          />
                                          <span className="left-side-span">
                                            Disbursed Amount
                                          </span>
                                        </Typography>
                                        <Typography className="mainHeadingValueMobile">
                                          {formatIndianRupees(item?.loanAmount)}
                                        </Typography>
                                        {/* Calculate and display the dynamic percentage */}
                                        <Typography className="mainHeadingPerValueMobile">
                                          {handlePercentAmount(
                                            item?.loanAmount,
                                            item?.repayAmount,
                                            "disburse"
                                          )}
                                          % used
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6} lg={6}>
                                        <Typography className="mainHeadingLable  text-align-right">
                                          <span className="right-side-span">
                                            Sanctioned Amount
                                          </span>
                                          <img
                                            src={AvailableIcon}
                                            alt="Available"
                                            style={{
                                              height: "22px",
                                            }}
                                          />
                                        </Typography>
                                        <Typography className="mainHeadingValueMobile text-align-right mainHeadingValueMobileRight">
                                          {formatIndianRupees(
                                            item?.repayAmount
                                          )}
                                        </Typography>
                                        {/* Calculate and display the dynamic percentage */}
                                        <Typography className="mainHeadingPerValueMobile text-align-right">
                                          {handlePercentAmount(
                                            item?.loanAmount,
                                            item?.repayAmount,
                                            "sanction"
                                          )}
                                          % left
                                        </Typography>
                                      </Grid>

                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                      >
                                        <Box
                                          sx={{ width: "100%", marginTop: 1 }}
                                        >
                                          <MultiColorProgressBarMobile
                                            variant="determinate"
                                            value={parseInt(
                                              checkPercentage(item)
                                            )} // Dynamic percentage
                                          />
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={7}
                                  md={7}
                                  lg={7}
                                  className="dashboard-container-mobile"
                                >
                                  <Grid container spacing={spacing}>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography className="insidePageLableMobile">
                                        Loan Amount
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {formatIndianRupees(item?.loanAmount)}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography
                                        className="insidePageLableMobile"
                                        style={{ marginTop: "2px" }}
                                      >
                                        ROI
                                        {item.morat && (
                                          <Tooltip
                                            placement="top"
                                            title={"ROI post Moratorium"}
                                            enterTouchDelay={50}
                                          >
                                            <img
                                              src={InfoIcon}
                                              alt="Status"
                                              className="imgicon"
                                            />
                                          </Tooltip>
                                        )}
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {formatNumberToTwoDecimals(
                                          item?.outstandingPrincipal
                                        )}
                                        %
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography className="insidePageLableMobile">
                                        Next Repay Amount
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {formatIndianRupees(item?.emiAmount)}
                                      </Typography>
                                    </Grid>
                                  </Grid>

                                  <Grid container spacing={spacing} mt={1}>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography className="insidePageLableMobile">
                                        Next Repay Date
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {formatDate(item?.nextEmiDate)}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography className="insidePageLableMobile">
                                        Loan Tenure (Months)
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {item?.loanTenure}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4}>
                                      <Typography className="insidePageLableMobile">
                                        Loan Start Date
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        className="insidePageValueMobile"
                                      >
                                        {formatDate(item?.loanStartDate)}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid container sm className="mt-20 mb-20">
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "right",
                                      alignItems: "right",
                                    }}
                                  >
                                    <Box sx={{ float: "right" }}>
                                      <OutlinedSmallButton
                                        title={"Request Fund Release"}
                                        click={() =>
                                          requestForDisbursement(
                                            item?.lanNumber,
                                            item?.isExistDisbursementAllowdLoan,
                                            item?.status
                                          )
                                        }
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {!isXsOrSm && (
                            <Grid container sm className="mt-20">
                              <Grid item xs={12} sm={7} md={7} lg={7}>
                                <Grid container spacing={spacing}>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Typography className="insidePageLable">
                                      Loan Amount
                                    </Typography>
                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                    >
                                      {formatIndianRupees(item?.loanAmount)}
                                    </Typography>
                                  </Grid>
                                  <Grid item sm={4}>
                                    <Typography
                                      className="insidePageLable"
                                      style={{ marginTop: "2px" }}
                                    >
                                      ROI
                                      {item.morat && (
                                        <Tooltip
                                          placement="top"
                                          title={"ROI post Moratorium"}
                                        >
                                          <img
                                            src={InfoIcon}
                                            alt="Status"
                                            className="imgicon"
                                          />
                                        </Tooltip>
                                      )}
                                    </Typography>

                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                      style={{ marginTop: "-3px" }}
                                    >
                                      {formatNumberToTwoDecimals(
                                        item?.outstandingPrincipal
                                      )}{" "}
                                      %
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Typography className="insidePageLable">
                                      Next Repay Amount
                                    </Typography>
                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                    >
                                      {formatIndianRupees(item?.emiAmount)}
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <Grid container spacing={spacing}>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Typography className="insidePageLable">
                                      Next Repay Date
                                    </Typography>
                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                    >
                                      {formatDate(item?.nextEmiDate)}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Typography className="insidePageLable">
                                      Loan Tenure (Months)
                                    </Typography>
                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                    >
                                      {item?.loanTenure}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Typography className="insidePageLable">
                                      Loan Start Date
                                    </Typography>
                                    <Typography
                                      variant="subtitle1"
                                      className="insidePageValue"
                                    >
                                      {formatDate(item?.loanStartDate)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={5} md={5} lg={5}>
                                <div style={{ display: "flex" }}>
                                  <div className="line-container">
                                    <div className="line vertical"></div>
                                    <div className="line vertical"></div>
                                  </div>
                                  <Grid
                                    container
                                    sm
                                    className="muiLinearProgress"
                                  >
                                    {/* Utilised Section */}
                                    <Grid
                                      item
                                      xs={6}
                                      sm={6}
                                      md={6}
                                      lg={6}
                                      className="right-border"
                                    >
                                      <Typography className="mainHeadingLable muiLinear-progress-p">
                                        <img
                                          src={UtilizedIcon}
                                          alt="Available"
                                          style={{
                                            height: "22px",
                                          }}
                                        />
                                        <span className="left-side-span">
                                          Disbursed Amount
                                        </span>
                                      </Typography>
                                      <Typography className="mainHeadingValue">
                                        {formatIndianRupees(item?.loanAmount)}
                                      </Typography>
                                      {/* Calculate and display the dynamic percentage */}
                                      <Typography className="mainHeadingPerValue">
                                        {handlePercentAmount(
                                          item?.loanAmount,
                                          item?.repayAmount,
                                          "disburse"
                                        )}
                                        % used
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={6} lg={6}>
                                      <Typography className="mainHeadingLable  text-align-right">
                                        <span className="right-side-span">
                                          Sanctioned Amount
                                        </span>
                                        <img
                                          src={AvailableIcon}
                                          alt="Available"
                                          style={{
                                            height: "22px",
                                          }}
                                        />
                                      </Typography>
                                      <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                                        {formatIndianRupees(item?.repayAmount)}
                                      </Typography>
                                      {/* Calculate and display the dynamic percentage */}
                                      <Typography className="mainHeadingPerValue text-align-right">
                                        {handlePercentAmount(
                                          item?.loanAmount,
                                          item?.repayAmount,
                                          "sanction"
                                        )}
                                        % left
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                      <Box sx={{ width: "100%", marginTop: 3 }}>
                                        <MultiColorProgressBar
                                          variant="determinate"
                                          value={parseInt(
                                            checkPercentage(item),
                                          )} // Dynamic percentage
                                        />
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </div>
                              </Grid>
                            </Grid>
                          )}
                        </Card>
                      </Box>
                    </>
                  ))}
                </Box>
              </>
            )}
          </Grid>
          <Grid container spacing={2}>
            {/* Section with 6 Cards */}
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {isXsOrSm && ((sanctionedDisbursedData[0]?.status === "A" || TermLoanDashboardData[0]?.status === "A")) && (
                <section className="document-container">
                  <Box sx={{ marginTop: "18px" }}>
                    
                    <Carousel
                      responsive={{
                        mobile: {
                          breakpoint: { max: 464, min: 0 },
                          items: 1,
                        },
                      }}
                        itemClass="carousel-item-padding-aws"
                        swipeable={true}
                        draggable={true}
                        showDots={false}
                        key={window.location.pathname || "aws-referral-carousel"}
                        infinite={isShowOtherBannerWithoutCarousel()  ? false : true}
                        arrows={false}
                        ssr={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        keyBoardControl={true}
                        customTransition="transform 300ms ease-in-out"
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                        deviceType={isXsOrSm ? "mobile" : "desktop"}
                        dotListClass="custom-dot-list-style"
                        partialVisible={true}
                        centerMode={false}
                        minimumTouchDrag={50}
                    >
                      {referralBannerCarousel(isShowOtherBannerWithoutCarousel())?.map((banner: any, index: number) => (
                        <Card key={index} sx={{ height: "auto" }}>
                          <CardActionArea
                            // onClick={() => window.open(banner.link, "_blank")}
                            onClick={() => {
                              if(index == 0) {
                                window.open(banner.link, "_blank")
                              } else {
                                setIsAwsOfferModalOpen(true);
                              }
                            }}
                          >
                            <CardMedia
                              component="img"
                              image={banner.image}
                              alt="Referral banner"
                            />
                          </CardActionArea>
                        </Card>
                      ))}
                    </Carousel>
                  </Box>
                </section>
              )}
              <section className="document-container">
                <Typography
                  sx={{
                    fontSize: "clamp(12px, 1.2vw, 14px)",
                    color: "#168794",
                    lineHeight: "2.0",
                  }}
                  gutterBottom
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ marginTop: isXsOrSm ? "15px" : "10px" }}
                  >
                    <span className="loan-account-sub-headings">
                      Quick Help
                    </span>
                  </Box>
                </Typography>
                <Grid container spacing={2}>
                  {quickLinks?.map((data: any, index: any) => (
                    <Grid item xs={6} sm={6} md={4} key={index}>
                      <CustomCard
                        title={data?.title}
                        icon={data?.icon}
                        loanTypeName={
                          TermLoanDashboardData[0]?.loanTypeName || ""
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </section>
            </Grid>
            {!isXsOrSm && isShowBanner() &&
            (
              <Grid item xs={12} sm={6} md={4}>
                <section
                  style={{ height: "172px", maxWidth: "421px" }}
                  className="document-container"
                >
                  <>
                    <Typography
                      sx={{
                        fontSize: "clamp(12px, 1.2vw, 14px)",
                        color: "#168794",
                        lineHeight: "2.0",
                      }}
                      gutterBottom
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ marginTop: "44px" }}
                      >
                        {/* <span className="loan-account-sub-headings">
                          Refer a Friend
                        </span> */}
                      </Box>
                    </Typography>
                    <Carousel
                      responsive={{
                        desktop: {
                          breakpoint: { max: 3000, min: 1024 },
                          items: 1,
                        },
                      }}
                       swipeable={true}
                        draggable={true}
                        showDots={false}
                        key={window.location.pathname || "aws-referral-carousel"}
                        infinite={true}
                        arrows={false}
                        ssr={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        keyBoardControl={true}
                        itemClass="carousel-item-padding-aws"
                        customTransition="transform 300ms ease-in-out"
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                        deviceType={isXsOrSm ? "mobile" : "desktop"}
                        dotListClass="custom-dot-list-style"
                        partialVisible={true}
                        centerMode={false}
                        minimumTouchDrag={50}
                    >
                      {awsReferralBannerDesktop.map((item, index) => (
                        <ImageSection
                          key={index}
                          onClick={() => setIsAwsOfferModalOpen(true)}
                        >
                          <img src={item.image} alt="" />
                        </ImageSection>
                      ))}
                    </Carousel>
                  </>
                </section>
              </Grid>
            )}
            {
              !isXsOrSm && isShowOtherBannerWithoutCarousel() && 
              <Grid item xs={12} sm={6} md={4}>
                <section
                  style={{ height: "172px", maxWidth: "421px" }}
                  className="document-container"
                >
                  <Box  sx={{ marginTop: "48px", cursor: "pointer", height: "100%" }} onClick={() => {
                    window.open(referralBannerCarousel(isShowOtherBannerWithoutCarousel())[0].link, "_blank")
                  }}>
                    <img src={referralBannerCarousel(isShowOtherBannerWithoutCarousel())[0].image} alt="Referral Banner" style={{ width: "100%", height: "100%" }} />
                </Box>
                </section>
              </Grid>
            }
            {(!isXsOrSm && (TermLoanDashboardData[0]?.status !== "A"
            )) && 
              (<Grid item xs={12} sm={6} md={4}>
                <section
                  style={{ height: "172px", maxWidth: "421px" }}
                  className="document-container"
                >
                  <Box  sx={{ marginTop: "48px", height: "100%" }}>
                    <img src={LoanManagementImg} alt="Loan Management" style={{ width: "100%", height: "100%" }} />
                </Box>
                </section>
              </Grid>)}
          </Grid>
          {isAwsOfferModalOpen && <AwsOfferModal isAwsOfferModalOpen={isAwsOfferModalOpen} setIsAwsOfferModalOpen={setIsAwsOfferModalOpen} />}

          <Box sx={{ marginTop: isXsOrSm ? "20px" : "19px" }}>
            <HeadingLeftRight
              titleone="Disbursement History (Last 5)"
              titletwo="View all"
              onRightSectionClick={handleViewAll}
              displayC="true"
            />
          </Box>
          {isXsOrSm && <CardItemListDashboard />}
          {!isXsOrSm && <DisbursementHistoryTable showAllData={false} />}
        </Box>
      )}
      {/* <Statement/> */}
      {selectedIndex === 3 && <DocumentTerm />}
      {selectedIndex === 1 && <DisbursementContainer />}
      {selectedIndex === 2 && <PaymentTermLoan />}
      {selectedIndex === 4 && (
        <Box mt={2}>
          <HeadingLeftRight titleone="Disbursement History" titletwo="" />
          {isXsOrSm ? (
            <>
              <Card sx={{ marginBottom: "10px" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    pl: 2,
                  }}
                >
                  <AccountSelectorDropDown
                    labelText="Loan account number"
                    buttonText=" N/A"
                    isActive={""}
                    backgroundColor="transparent"
                    borderWidth="0px"
                    marginTop="0px"
                  />
                </Box>
              </Card>
              <CardItemListHistory />
            </>
          ) : (
            <DisbursementHistoryTable showAllData={true} />
          )}
        </Box>
      )}

      <ModalPopup
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="Refer Now"
        // style={commonStyles.mainModal}
        onNavigate={() => { }}
        style={{ width: "100%", height: "630px" }}
        // childrenAction={
        //   <Box
        //     sx={{
        //       width: "100%",
        //       borderTop: "1px solid #ddd",
        //       textAlign: "center",
        //       bottom: 0,
        //     }}
        //   >
        //     <ErrorButton onClick={() => handleCloseModal()} fullWidth={true}>
        //       Close
        //     </ErrorButton>
        //   </Box>
        // }
      >
        {/* <Box sx={{ paddingTop: "20px", paddingBottom: "20px" }}>
          <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#00B3B5" }}>
            Referrer / Existing Customer
          </Typography>
          <Box>
            <div style={{ paddingBottom: "5px", paddingTop: "10px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"Name"}
              </label>
            </div>
            <InputField
              padding="7px 14px 7px 0px"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Name"
              value={userProfile?.name}
              disabled
            />
          </Box>
        </Box> */}

        {/* <Divider /> */}

        <Box sx={{ paddingTop: "20px" }}>
          <Box>
            <div style={{ paddingBottom: "5px", paddingTop: "10px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"First Name"}
                <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <InputField
              onChange={(event: any) => handleSetFormValue(event)}
              name={"firstName"}
              padding="7px 14px 7px 0px"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="First Name"
              inputProps={{ maxLength: 50 }}
            />
          </Box>

          <Box sx={{ paddingTop: "10px" }}>
            <div style={{ paddingBottom: "5px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"Last Name"}
                <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <InputField
              onChange={(event: any) => handleSetFormValue(event)}
              name={"lastName"}
              padding="7px 14px 7px 0px"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Last Name"
              inputProps={{ maxLength: 50 }}
            />
          </Box>

          <Box sx={{ paddingTop: "10px" }}>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <label
                  htmlFor="custom-autocomplete"
                  className="disbursement-inside-page-lable-condtion-dark"
                  style={{ color: "rgba(165, 163, 174)" }}
                >
                  {"Country Code"}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <SearchSelectOptions
                  options={phoneCodeOptions}
                  isMandatory={false}
                  onChange={(value: any) => handleSetPhoneCode(value)}
                  width={300}
                  value={formValue?.countryCodeId}
                />
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={8}>
                <label
                  htmlFor="custom-autocomplete"
                  className="disbursement-inside-page-lable-condtion-dark"
                  style={{ color: "rgba(165, 163, 174)" }}
                >
                  {"Mobile Number"}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <InputField
                  onChange={(event: any) => handleSetFormValue(event)}
                  name={"phone"}
                  padding="7px 14px 7px 0px"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="Mobile Number"
                  inputProps={{
                    minLength: 7,
                    maxLength: 15,
                    inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices
                    pattern: "[0-9]*", // Ensures only digits are allowed

                    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                      // Block non-numeric key presses
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "Delete"
                      ) {
                        e.preventDefault();
                      }
                    },
                  }}
                />
                <Typography
                  sx={{ fontSize: "12px", fontWeight: "400", color: "#EA5455" }}
                >
                  {" "}
                  {mobileNumberError &&
                    "Mobile Number should be more than 7 digit."}{" "}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ paddingTop: "10px" }}>
            <div style={{ paddingBottom: "5px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"Email ID"}
                <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <InputField
              onChange={(event: any) => handleSetFormValue(event)}
              name={"emailId"}
              padding="7px 14px 7px 0px"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Email ID"
              type="email"
            />
          </Box>

          <Box sx={{ paddingTop: "10px" }}>
            <div style={{ paddingBottom: "5px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"Course Name"}
                <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <InputField
              onChange={(event: any) => handleSetFormValue(event)}
              name={"course"}
              padding="7px 14px 7px 0px"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Course Name*"
            />
          </Box>

          <Box sx={{ paddingTop: "10px" }}>
            <div style={{ paddingBottom: "5px" }}>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{ color: "rgba(165, 163, 174)" }}
              >
                {"Preferred Country to Study"}
                <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <SearchSelectOptions
              options={
                countryList?.map((bd: any) => ({
                  value: bd.id,
                  label: bd.country,
                })) || []
              }
              // label="Disbursement Purpose"
              isMandatory={false}
              // name="country"
              value={formValue.countryId}
              onChange={(value: any) => handleSetCountryField(value)}
            />
          </Box>

          <Box sx={{ paddingTop: "20px" }}>
            <PrimaryButton
              fullWidth={true}
              type={"submit"}
              disabled={
                !formValue.firstName ||
                !formValue.lastName ||
                !formValue.phone ||
                !formValue.emailId ||
                !formValue.countryId ||
                !formValue.course ||
                !formValue.countryCodeId
              }
              onClick={handleContinue}
            >
              Submit
            </PrimaryButton>
          </Box>

          {/* <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#00B3B5" }}>
              Refer Now
            </Typography> */}
        </Box>
      </ModalPopup>
    </React.Fragment>
  );
};

export default TermLoanDashboard;
